/* The Finance Fixeee — light theme JS */
document.addEventListener('click', function (e) {
  var thumb = e.target.closest('[data-gallery-thumb]');
  if (thumb) {
    var gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main]');
    var src = thumb.getAttribute('data-full');
    if (main && src) main.setAttribute('src', src);
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
  }

  var burger = e.target.closest('[data-menu-toggle]');
  if (burger) {
    var menu = document.querySelector('[data-mobile-menu]');
    var isOpen = menu.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', isOpen);
    burger.classList.toggle('is-active', isOpen);
  } else if (!e.target.closest('[data-mobile-menu]')) {
    var openMenu = document.querySelector('[data-mobile-menu].is-open');
    if (openMenu) {
      openMenu.classList.remove('is-open');
      document.querySelector('[data-menu-toggle]').setAttribute('aria-expanded', 'false');
      document.querySelector('[data-menu-toggle]').classList.remove('is-active');
    }
  }
});
